var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFAF66",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6L8 .256 6 6H0l4.89 3.828-1.922 5.916L8 12.088l5.032 3.656-1.922-5.916L16 6zM30 5.744L28 0l-2 5.744h-6l4.89 3.828-1.922 5.916L28 11.832l5.032 3.656-1.922-5.916L36 5.744zM50 5.744L48 0l-2 5.744h-6l4.89 3.828-1.922 5.916L48 11.832l5.032 3.656-1.922-5.916L56 5.744zM70 5.744L68 0l-2 5.744h-6l4.89 3.828-1.922 5.916L68 11.832l5.032 3.656-1.922-5.916L76 5.744zM90 5.744L88 0l-2 5.744h-6l4.89 3.828-1.922 5.916L88 11.832l5.032 3.656-1.922-5.916L96 5.744z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars5);
export default __webpack_public_path__ + "static/media/stars-5.12aef9f571f388e07ad960f133391ba0.svg";
export { ForwardRef as ReactComponent };